// Agent IDs for ElevenLabs
export const WRAP_UP_AGENT_ID = 'agent_01jxcfxp6pfwtatescm7k3xprm';
export const TECHNICAL_INTERVIEW_AGENT_ID =
  process.env.NEXT_PUBLIC_TECHNICAL_INTERVIEW_AGENT_ID;

// Static introduction question
export const INTRODUCTION_QUESTION = {
  message:
    "Hello, nice to meet you. I'm your AI interviewer for the MERN Engineer position. We'll start with a 10-minute discussion about your MERN stack experience. The results will be saved in your profile and may be shared with future employers. Please begin with a brief introduction of yourself by pressing the start recording button.",
  role: 'agent'
};

export const OUTRO_QUESTION = {
  message: 'Thank you for your time',
  role: 'agent'
};

export const WRAP_UP_QUESTIONS = [
  {
    message:
      'Did I miss something to ask you, or something you would like to add?',
    role: 'agent'
  },
  {
    message:
      "We're actively working on developing the Cruit interview process, and we'd love to hear your thoughts and feedback on it. Your insights are invaluable to us!",
    role: 'agent'
  }
];

// States for the interview flow
export const STATE = {
  START_INTERVIEW: 'START_INTERVIEW',
  AGENT_ASKING: 'AGENT_ASKING',
  PRESS_TO_RECORD: 'PRESS_TO_RECORD',
  USER_SPEAKING: 'USER_SPEAKING',
  END: 'END'
} as const;

const DEV_INTERVIEW_DURATION = 1 * 60;
const DEV_WRAP_UP_INTERVIEW_DURATION = 1 * 60;

const PROD_INTERVIEW_DURATION = 10 * 60;
const PROD_WRAP_UP_INTERVIEW_DURATION = 2 * 60;

export const INTERVIEW_DURATION =
  process.env.NODE_ENV === 'development'
    ? DEV_INTERVIEW_DURATION
    : PROD_INTERVIEW_DURATION;
